import React from 'react';
import { AlertCircle, CheckCircle } from 'lucide-react';

const ConfirmModal = ({
                          isOpen,
                          onClose,
                          onConfirm,
                          title,
                          message,
                          confirmText = 'Подтвердить',
                          cancelText = 'Отмена',
                          type = 'warning' // warning, danger, success
                      }) => {
    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    const getTypeStyles = () => {
        switch (type) {
            case 'danger':
                return {
                    icon: AlertCircle,
                    iconColor: 'text-red-600',
                    buttonColor: 'bg-red-500 hover:bg-red-600',
                    bgColor: 'bg-red-50'
                };
            case 'success':
                return {
                    icon: CheckCircle,
                    iconColor: 'text-green-600',
                    buttonColor: 'bg-green-500 hover:bg-green-600',
                    bgColor: 'bg-green-50'
                };
            default:
                return {
                    icon: AlertCircle,
                    iconColor: 'text-yellow-600',
                    buttonColor: 'bg-[#2b6c8e] hover:bg-[#234d6a]',
                    bgColor: 'bg-yellow-50'
                };
        }
    };

    const typeStyles = getTypeStyles();
    const Icon = typeStyles.icon;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-fadeIn">
                <div className={`${typeStyles.bgColor} rounded-lg p-4 mb-6`}>
                    <div className="flex items-start gap-3">
                        <Icon className={`w-6 h-6 ${typeStyles.iconColor} flex-shrink-0 mt-0.5`} />
                        <div>
                            <h3 className="font-bold text-gray-900 text-lg mb-2">{title}</h3>
                            <p className="text-gray-700">{message}</p>
                        </div>
                    </div>
                </div>

                <div className="flex gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        onClick={handleConfirm}
                        className={`flex-1 px-6 py-3 ${typeStyles.buttonColor} text-white rounded-lg transition-colors font-medium`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
